import React, { useEffect, useState } from 'react';
import MemberLayout from '../../components/MemberLayout';
import { getMyDocuments, uploadDocument } from '../../services/api';

export default function Documents() {
  const [documents, setDocuments] = useState([]);
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const loadDocuments = () => {
    getMyDocuments().then((res) => setDocuments(res.data)).catch(() => {});
  };

  useEffect(() => { loadDocuments(); }, []);

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) return;
    setUploading(true);
    setError('');
    try {
      const formData = new FormData();
      formData.append('file', file);
      await uploadDocument(formData);
      setFile(null);
      loadDocuments();
    } catch (err) {
      setError('Upload failed. Please try a smaller file (max 10MB).');
    } finally {
      setUploading(false);
    }
  };

  return (
    <MemberLayout title="Documents">
      <form onSubmit={handleUpload} className="card" style={{ marginBottom: 24, maxWidth: 520 }}>
        <div className="form-group">
          <label>Upload a Document</label>
          <input type="file" onChange={(e) => setFile(e.target.files[0])} />
          <p style={{ fontSize: '0.8rem', color: 'var(--color-grey)', marginTop: 6 }}>
            Employment contracts, payslips, warning letters, dismissal letters, correspondence, photos, videos or voice notes.
          </p>
        </div>
        {error && <p className="error-text">{error}</p>}
        <button className="btn btn-gold" disabled={!file || uploading}>{uploading ? 'Uploading...' : 'Upload'}</button>
      </form>

      {documents.length === 0 ? (
        <p>No documents uploaded yet.</p>
      ) : (
        <div className="card">
          <ul style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {documents.map((d) => (
              <li key={d.id} style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #eee', paddingBottom: 10 }}>
                <span>{d.fileName}</span>
                <span style={{ fontSize: '0.8rem', color: 'var(--color-grey)' }}>
                  {d.uploadedBy === 'MEMBER' ? 'Uploaded by you' : 'Uploaded by organisation'}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </MemberLayout>
  );
}
